import { ReactNode } from 'react';
import './score-card.css';

interface ScoreCardProps {
  name: string;
  score: number | string;
  children?: ReactNode;
}

export const ScoreCard: React.FC<ScoreCardProps> = ({ name, score, children }) => (
  <div className='score-data-container'>
    <div className='score-name'>{name}</div>
    <div className='score-number'>{score}pts</div>
    {children}
  </div>
);
